// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__WbJez","title":"Banner_title__hB2y3","accent":"Banner_accent__XeL0L"};